module.exports = __webpack_public_path__ + "assets/img/100101.3d9511c0.png";